/** How a fact the rules ask for is named to a person. One home, because the same missing-fact name
 * reaches two screens: Financials (where it is asked for) and Readiness (where a position waits on
 * it). Readiness printed the key - "Needs these before we can say: uk_energy_kwh" - on a new
 * Admin's first filing (journey walk, 2026-10-31), because only Financials held the table.
 */

import type { FigureKey } from "../api/readiness";

/** The questions, as a person reads them. Wording only — what an answer *means* is the rules'. */
export const QUESTIONS: Record<string, string> = {
  is_quoted: "Is it a quoted company?",
  is_public_company: "Is it a public company?",
  does_business_in_california: "Does it do business in California?",
  is_insurance_business: "Is it an insurance business?",
  included_in_parent_group_report: "Is it included in its parent’s group report?",
};

/** A yes/no question as a person reads it. A regime loaded as data names its own fact, and the
 * wording table above does not know it, so the fallback is the fact's name spoken as a question
 * ("operates_in_zedland" becomes "Operates in zedland?"). Wording only - what an answer *means* is
 * the rules'. */
export function question(fact: string): string {
  const known: Record<string, string> = QUESTIONS;
  if (known[fact]) return known[fact];
  const spoken = fact.replace(/_/g, " ");
  return `${spoken.charAt(0).toUpperCase()}${spoken.slice(1)}?`;
}

export const LABELS: Record<FigureKey, string> = {
  turnover: "Turnover",
  balance_sheet_total: "Balance sheet total",
  employees: "Employees",
  revenue_usd: "Revenue (USD)",
  prior_year_revenue_usd: "Prior-year revenue (USD)",
  group_turnover_net: "Group turnover, net",
  group_turnover_gross: "Group turnover, gross",
  group_balance_sheet_net: "Group balance sheet, net",
  group_balance_sheet_gross: "Group balance sheet, gross",
  group_employees: "Group employees",
  uk_energy_kwh: "UK energy use (kWh)",
};

/** A fact's name as a person reads it, falling back to the name itself: a label this table does not
 * hold must still be shown, and a guess would be a second home for the fact's name. */
export function factLabel(fact: string): string {
  const known: Record<string, string> = { ...QUESTIONS, ...LABELS };
  return known[fact] ?? fact;
}

